import { createStack, createFetch, method, base, accept, parse, json } from 'http-client';
import { api } from "../../config/api-config.js";
import memoizeResolved from "./helpers/memoizeResolved";
import { timeout, handleKjson } from "./middlewares";
export var geoStack = createStack(method('POST'), base(api.geo.host), accept('application/json'), parse('json', 'response'), timeout(api.geo.timeout), handleKjson());
var fetchNearestAirport = memoizeResolved(function (ip) {
  var search = createFetch(geoStack, json({
    endpoint: 'geo.nearest.position',
    data: ip && {
      ip: ip
    }
  }));
  return search('/');
});
var fetchNearestByIata = memoizeResolved(function (code) {
  var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var search = createFetch(geoStack, json({
    endpoint: 'geo.radius.cities',
    data: {
      code: code,
      radius: radius
    }
  }));
  return search('/');
}, function (code, radius) {
  return "".concat(code).trim().toLowerCase() + (radius || '');
});
var fetchCoordsByIata = memoizeResolved(function (code) {
  var search = createFetch(geoStack, json({
    endpoint: 'iata.coords',
    data: {
      code: code
    }
  }));
  return search('/');
});
export default fetchNearestAirport;
export { fetchNearestAirport, fetchNearestByIata, fetchCoordsByIata };